import { render, staticRenderFns } from "./ContactCompanyInfo.vue?vue&type=template&id=2cd47828&"
import script from "./ContactCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./ContactCompanyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports